'use strict'

import Vue from 'vue'
import Api from '@/api/analytics.js'

const state = {
  loading: false,
  error: null,
  statuses: [],
  allStatuses: [],
  selectedStatus: []
}

const actions = {
  fetch ({ commit, dispatch }, params) {
    commit('fetch')

    return Api.fetchFunnel(params)
      .then(res => commit('fetchSuccess', res))
      .catch(err => {
        dispatch('global/setError', err, { root: true })
        commit('fetchFailure', err)
      })
  },

  fetchStatuses({commit, dispatch}) {
    return Api.fetchStatuses()
      .then(data => commit('fetchStatuses', data))
      .catch(err => {
        commit('fetchFailure', err)
        return Promise.reject(err)
      })
  },

  updateStatuses({commit, dispatch}, params) {
    return Api.updateStatuses(params)
      .then(data => commit('fetchStatuses', data))
      .catch(err => {
        commit('fetchFailure', err)
        return Promise.reject(err)
      })
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, res) {
    state.statuses = res
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
  },

  select (state, status) {
    const index = state.selectedStatus.findIndex(response => response.id === status.id);
    const exists = !!~index;

    if (status.selected && !exists) {
      status.is_hidden = false;
      state.selectedStatus.push(status);
    } else if (!status.selected && exists) {
      status.is_hidden = true;
      Vue.delete(state.selectedStatus, index);
    }
  },

  selectAll (state, value) {
    state.selectedStatus = [];

    if (value) {
      state.allStatuses.forEach((response) => {
        response.selected = true;
        response.is_hidden = false;
        state.selectedStatus.push(response);
      })
    } else {
      state.allStatuses.forEach((response) => {
        response.selected = false;
        response.is_hidden = true;
      })
    }
  },

  fetchStatuses(state, data) {
    state.selectedStatus = [];
    state.allStatuses = data;
    state.allStatuses.sort((a, b) => a.priority - b.priority);
    state.allStatuses.forEach((response) => {
      if (!response.is_hidden) {
        response.selected = true;
        state.selectedStatus.push(response);
      }
    })
    state.loading = false;
  }
}

const getters = {
  statuses: (state) => state.statuses,
  allStatuses: (state) => state.allStatuses,
  loading: (state) => state.loading,
  selectedList: (state, getters) => state.selectedStatus,
  isSelectedAll: (state, getters) => state.selectedStatus.length === state.allStatuses.length
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
